import Dialog from 'components/overlays/Dialog';
import type { Scenario } from 'features/simulations-v2/types';

import CreateSimulationForm from './CreateSimulationForm';

interface Props {
    show: boolean;
    scenarios: Scenario[];
    onClose: () => void;
    onSuccess: () => void;
}

const CreateSimulationDialog = ({ show, scenarios, onClose, onSuccess }: Props) => (
    <Dialog
        show={show}
        title='Create new simulation'
        body={<CreateSimulationForm scenarios={scenarios} onCancel={onClose} onSuccess={onSuccess} />}
        onClose={onClose}
        showCloseButton
    />
);

export default CreateSimulationDialog;
